/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Service_Level_Compare_Premium_TitleInputs */

const en_subscription_service_level_compare_premium_title = /** @type {(inputs: Subscription_Service_Level_Compare_Premium_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const ar_subscription_service_level_compare_premium_title = /** @type {(inputs: Subscription_Service_Level_Compare_Premium_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احترافي`)
};

const de_subscription_service_level_compare_premium_title = /** @type {(inputs: Subscription_Service_Level_Compare_Premium_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const es_subscription_service_level_compare_premium_title = /** @type {(inputs: Subscription_Service_Level_Compare_Premium_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const fr_subscription_service_level_compare_premium_title = /** @type {(inputs: Subscription_Service_Level_Compare_Premium_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const it_subscription_service_level_compare_premium_title = /** @type {(inputs: Subscription_Service_Level_Compare_Premium_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const ja_subscription_service_level_compare_premium_title = /** @type {(inputs: Subscription_Service_Level_Compare_Premium_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const ko_subscription_service_level_compare_premium_title = /** @type {(inputs: Subscription_Service_Level_Compare_Premium_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const pt_br_subscription_service_level_compare_premium_title = /** @type {(inputs: Subscription_Service_Level_Compare_Premium_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const ru_subscription_service_level_compare_premium_title = /** @type {(inputs: Subscription_Service_Level_Compare_Premium_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const th_subscription_service_level_compare_premium_title = /** @type {(inputs: Subscription_Service_Level_Compare_Premium_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โปร`)
};

const tr_subscription_service_level_compare_premium_title = /** @type {(inputs: Subscription_Service_Level_Compare_Premium_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const zh_cn_subscription_service_level_compare_premium_title = /** @type {(inputs: Subscription_Service_Level_Compare_Premium_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专业版`)
};

const zh_tw_subscription_service_level_compare_premium_title = /** @type {(inputs: Subscription_Service_Level_Compare_Premium_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`專業版`)
};

/**
* | output |
* | --- |
* | "Pro" |
*
* @param {Subscription_Service_Level_Compare_Premium_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_service_level_compare_premium_title = /** @type {((inputs?: Subscription_Service_Level_Compare_Premium_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Service_Level_Compare_Premium_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_service_level_compare_premium_title(inputs)
	if (locale === "ar") return ar_subscription_service_level_compare_premium_title(inputs)
	if (locale === "de") return de_subscription_service_level_compare_premium_title(inputs)
	if (locale === "es") return es_subscription_service_level_compare_premium_title(inputs)
	if (locale === "fr") return fr_subscription_service_level_compare_premium_title(inputs)
	if (locale === "it") return it_subscription_service_level_compare_premium_title(inputs)
	if (locale === "ja") return ja_subscription_service_level_compare_premium_title(inputs)
	if (locale === "ko") return ko_subscription_service_level_compare_premium_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_service_level_compare_premium_title(inputs)
	if (locale === "ru") return ru_subscription_service_level_compare_premium_title(inputs)
	if (locale === "th") return th_subscription_service_level_compare_premium_title(inputs)
	if (locale === "tr") return tr_subscription_service_level_compare_premium_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_service_level_compare_premium_title(inputs)
	return zh_tw_subscription_service_level_compare_premium_title(inputs)
});